export const metersPerPixel = (zoom: number, lat: number): number => {
  return (156543.03 * Math.cos(lat * (Math.PI / 180))) / 2 ** zoom;
};
